import { DashboardFolderT, DashboardT } from 'business/definitions';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { isDashboardType } from './helpers';
import { Typography } from '@mui/material';
import Flex from 'ui/Flex/Flex';

export default function AccessCountCellRenderer({
    value: dashboard,
}: CellRendererParams<
    DashboardT | DashboardFolderT
>): React.ReactElement | null {
    if (!isDashboardType(dashboard))
        return (
            <Typography
                sx={{
                    textAlign: 'center',
                    alignContent: 'center',
                    height: '100%',
                }}
            >
                -
            </Typography>
        );
    if (!dashboard) return null;
    return (
        <Flex alignItems="center" justifyContent="center" gap={1}>
            <VisibilityIcon />
            {dashboard.readUserAccessCount}
            <EditIcon />
            {dashboard.writeUserAccessCount}
        </Flex>
    );
}
